/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MobileNotificationDetailsViewModel } from "../types/MobileNotificationDetailsViewModel.ts";

export const mobileNotificationDetailsViewModelSchema = z.object({
  title: z.string().describe("Título da notificação.").nullish(),
  message: z.string().describe("Corpo da notificação.").nullish(),
  totalStudentsSent: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de tokens de alunos para os quais a notificação foi disparada (soma de todos os status).",
      ),
  ),
  totalStudentsSuccessful: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de tokens de alunos que receberam a notificação com sucesso (status Sent).",
      ),
  ),
  totalFailed: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de tokens de alunos com falha no envio (status Failed).",
      ),
  ),
  classStudentNames: z
    .array(z.string())
    .describe("Lista com os nomes de todas as turmas associadas à notificação.")
    .nullish(),
  sentFullAt: z.string().datetime().nullish(),
}) as unknown as ToZod<MobileNotificationDetailsViewModel>;
